import classNames from 'classnames';
import * as React from 'react';
import * as styles from './Shimmer.css';

interface IShimmerProps {
  running: boolean;
  theme: 'black' | 'white' | 'orange';
  children: React.ReactNode;
}

export const Shimmer = ({ running, theme, children }: IShimmerProps) => {
  return <div className={classNames(styles['shimmer'], styles[theme], running && styles['running'])}>{children}</div>;
};
